import React from 'react';
import { makeConnect } from '../../infrastructure/components/mobx-extensions';
import { AccountUsersVM } from './account-users.viewmodel';

const AccountUsersContext = React.createContext<AccountUsersVM>(null);
const connectAccountUsersVM = makeConnect(AccountUsersContext);

export { AccountUsersContext, connectAccountUsersVM };